
    document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.additional-description')) {
    const getVariantIdFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('variant');
};

    const logSelectedVariant = () => {
    const variantId = getVariantIdFromUrl();
    if (variantId) {
    const selectedVariantElement = document.querySelector(
    `.variant-with-subscription[data-variant-id="${variantId}"]`
    );
    if (selectedVariantElement) {
    const subscriptionPrice = parseFloat(selectedVariantElement.getAttribute('data-subscription'));
    const originalPrice = parseFloat(selectedVariantElement.getAttribute('data-price').replace(',', '.'));

    const salePriceElement = document.querySelector('.subscription-price');
    if (salePriceElement && subscriptionPrice) {
    // salePriceElement.textContent = `€${subscriptionPrice} per month`;
}

    const discountElement = document.querySelector('.save-wrapper');
    if (discountElement) {
    if (subscriptionPrice) {
    const discountAmount = (originalPrice - subscriptionPrice).toFixed(2);
        discountElement.style.display = 'block';
} else {
        discountElement.style.display = 'none';
}
}

    const subscriptionMainPrice = document.querySelector('.subscription-main-price');
    if (subscriptionMainPrice) {
    const comparePriceElement = subscriptionMainPrice.querySelector('.compare-price');
    const priceElement = subscriptionMainPrice.querySelector('.price');
    const mainDiscountElement = subscriptionMainPrice.querySelector('.discount');

    if (originalPrice > 0) {
    comparePriceElement.textContent = `€${originalPrice}`;
} else {
    comparePriceElement.textContent = `€${subscriptionPrice}`;
}

    const comparePrice = parseFloat(comparePriceElement.textContent.replace('€', ''));
    const mainDiscountAmount = (comparePrice - subscriptionPrice).toFixed(2);

    mainDiscountElement.textContent = `Save €${mainDiscountAmount}`;
    priceElement.textContent = `€${subscriptionPrice}`;
}

//     const additionalDescriptionElement = document.querySelector('.additional-description-container-one-time');
//     if (additionalDescriptionElement && subscriptionPrice) {
//     const discountAmount = (originalPrice - subscriptionPrice).toFixed(2);
//     additionalDescriptionElement.textContent = `Switch to a subscription and save ${discountAmount}
//     You can have the same for only ${subscriptionPrice}. Convenient way to get Free Shipping and best prices.`;
// }
}
}
};

    logSelectedVariant();

    window.addEventListener('popstate', logSelectedVariant);
    window.addEventListener('hashchange', logSelectedVariant);

    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    history.pushState = function (...args) {
    const result = originalPushState.apply(this, args);
    window.dispatchEvent(new Event('popstate'));
    return result;
};

    history.replaceState = function (...args) {
    const result = originalReplaceState.apply(this, args);
    window.dispatchEvent(new Event('popstate'));
    return result;
};

    const subscriptionContainer = document.querySelector('.variant-with-subscription-container');
    const deliveryFrequencyOptions = document.querySelectorAll('.delivery-frequency');

    const updateSubscriptionPrices = () => {
    const selectedPurchaseType = document.querySelector('input[name="option1"]:checked').value;
    const selectedSizeElement = document.querySelector('input[name="option2"]:checked');
    const hasSizeOption = Array.from(subscriptionContainer.children).some(
    (variant) => variant.textContent.trim().split('/').length === 3
    );
    const selectedSize = hasSizeOption && selectedSizeElement ? selectedSizeElement.value : null;

    deliveryFrequencyOptions.forEach((option) => {
    const originalText = option.getAttribute('data-frequency');
    option.textContent = originalText;
});

    const matchingVariants = Array.from(subscriptionContainer.children).filter((variant) => {
    const textContent = variant.textContent.trim();
    if (hasSizeOption) {
    return textContent.includes(selectedPurchaseType) && textContent.includes(selectedSize);
} else {
    return textContent.includes(selectedPurchaseType);
}
});

    matchingVariants.forEach((variant) => {
    const variantText = variant.textContent.trim();
    const subscriptionPrice = parseFloat(variant.getAttribute('data-subscription'));
    const originalPrice = parseFloat(variant.getAttribute('data-price').replace(',', '.'));

    if (subscriptionPrice) {
    const discountPercentage = Math.round(((originalPrice - subscriptionPrice) / originalPrice) * 100);
    const discountAmount = (originalPrice - subscriptionPrice).toFixed(2);

    deliveryFrequencyOptions.forEach((option) => {
    const frequency = option.getAttribute('data-frequency');
    if (variantText.includes(frequency)) {
    option.innerHTML = `<span>${frequency} €${subscriptionPrice}</span> <span>-${discountPercentage}%</span>`;
}
});

    const discountElement = document.querySelector('.save-wrapper');
    if (discountElement) {
    discountElement.style.display = 'block';
}

    const subscriptionMainPrice = document.querySelector('.subscription-main-price');
    if (subscriptionMainPrice) {
    const comparePriceElement = subscriptionMainPrice.querySelector('.compare-price');
    const priceElement = subscriptionMainPrice.querySelector('.price');
    const mainDiscountElement = subscriptionMainPrice.querySelector('.discount');

    if (originalPrice > 0) {
    comparePriceElement.textContent = `€${originalPrice}`;
} else {
    comparePriceElement.textContent = `€${subscriptionPrice}`;
}

    const comparePrice = parseFloat(comparePriceElement.textContent.replace('€', ''));
    const mainDiscountAmount = (comparePrice - subscriptionPrice).toFixed(2);

    mainDiscountElement.textContent = `Save €${mainDiscountAmount}`;
    priceElement.textContent = `€${subscriptionPrice}`;
}

    const additionalDescriptionElement = document.querySelector('.additional-description-container-one-time');
    if (additionalDescriptionElement && subscriptionPrice) {
    const discountAmount = (originalPrice - subscriptionPrice).toFixed(2);
    // additionalDescriptionElement.textContent = `Switch to a subscription and save €${discountAmount}. You can have the same for only €${subscriptionPrice}. Convenient way to get Free Shipping and best prices. You can change or cancel your subscription any time!`;
}
} else {
    const discountElement = document.querySelector('.save-wrapper');
    if (discountElement) {
        discountElement.style.display = 'none';
}

    const subscriptionMainPrice = document.querySelector('.subscription-main-price');
    if (subscriptionMainPrice) {
    const comparePriceElement = subscriptionMainPrice.querySelector('.compare-price');
    const priceElement = subscriptionMainPrice.querySelector('.price');
    const mainDiscountElement = subscriptionMainPrice.querySelector('.discount');

    comparePriceElement.textContent = '';
    priceElement.textContent = '';
    mainDiscountElement.textContent = '';
}
}
});
};

    updateSubscriptionPrices();

    document.querySelectorAll('input[name="option1"], input[name="option2"]').forEach((input) => {
    input.addEventListener('change', updateSubscriptionPrices);
});
}
});


    document.querySelectorAll('.product-accordion__button').forEach(button => {
        button.addEventListener('click', function() {
            this.classList.toggle('product-accordion__button_active');

            const content = this.nextElementSibling;
            const paddingBottom = 24;

            if (content.style.height) {
                content.style.height = null;
            } else {
                content.style.height = (content.scrollHeight + paddingBottom) + "px";
            }
        });
    });

    document.querySelectorAll('.accordion-toggle').forEach(button => {
        document.querySelectorAll('.accordions-and-image__accordions-item').forEach(item => {
            const content = item.querySelector('.accordions-and-image__accordions-item--body');
            content.style.height = 0;
        });

        button.addEventListener('click', function() {
            const accordionItem = this.closest('.accordions-and-image__accordions-item');
            const content = accordionItem.querySelector('.accordions-and-image__accordions-item--body');
            const additionalPadding = 16;

            if (content.style.height && content.style.height !== '0px') {
                content.style.height = 0;
                accordionItem.classList.remove('active');
            } else {
                const totalHeight = content.scrollHeight + additionalPadding;
                content.style.height = totalHeight + 'px';
                accordionItem.classList.add('active');
            }

            document.querySelectorAll('.accordions-and-image__accordions-item').forEach(item => {
                if (item !== accordionItem) {
                    const otherContent = item.querySelector('.accordions-and-image__accordions-item--body');
                    otherContent.style.height = 0;
                    item.classList.remove('active');
                }
            });
        });
    });

    document.querySelectorAll('.accordion-toggle').forEach(button => {
        document.querySelectorAll('.custom-faq__accordions-item').forEach(item => {
            const content = item.querySelector('.custom-faq__accordions-item--body');
            content.style.height = 0;
        });

        button.addEventListener('click', function() {
            const accordionItem = this.closest('.custom-faq__accordions-item');
            const content = accordionItem.querySelector('.custom-faq__accordions-item--body');
            const additionalPadding = 16;

            if (content.style.height && content.style.height !== '0px') {
                content.style.height = 0;
                accordionItem.classList.remove('active');
            } else {
                const totalHeight = content.scrollHeight + additionalPadding;
                content.style.height = totalHeight + 'px';
                accordionItem.classList.add('active');
            }

            document.querySelectorAll('.custom-faq__accordions-item').forEach(item => {
                if (item !== accordionItem) {
                    const otherContent = item.querySelector('.custom-faq__accordions-item--body');
                    otherContent.style.height = 0;
                    item.classList.remove('active');
                }
            });
        });
    });



    window.addEventListener('DOMContentLoaded', function() {
        const firstFieldset = document.querySelector('fieldset');

        if (firstFieldset) {
            const newContainer = document.createElement('div');
            newContainer.classList.add('product-info-new__banner-container');

            firstFieldset.parentNode.insertBefore(newContainer, firstFieldset.nextSibling);

            const banner = document.querySelector('.product-info-new__banner');
            if (banner) {
                newContainer.appendChild(banner);
                banner.style.display = 'flex';
            }
        }
    });